<template>
 <div>
    <div id="head_div">
      <div class="container">
        <span class="phone-span hidden-xs"><img src="@/assets/images/phone1.png"> 010-68311878（北京总部） （上海） 0755-23895517（深圳） （疫情期间，请联系：13901006625）</span>
        <div class="pull_right">
          <a style="padding-left:2px;font-size:12px;color:#F2F4F3;" href="http://www.hffss.com/">中文 /</a>
          <a style="padding-left:2px;font-size:12px;color:#F2F4F3;" href="http://en.hffss.com"> English</a>
        </div>
        <div class="pull_right phone-span">
            <a class="conmmon-a" data-toggle="modal" data-target="#eduModal" href="#" id="khfwpt">客户服务平台</a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg bg-body-tertiary navbar-dark bg-dark">
      <div class="container-fluid">
        <a class="navbar-left" href="http://www.hffss.com/Home/Index" style="padding:20px 0 0 0;">
            <img class="hidden-xs hidden-sm" src="@/assets/images/logo.png" style="width:100%;">
            <img class="visible-sm" src="@/assets/images/LOGO-Small.png" style="width:100%;max-width:100%;">
            <img class="visible-xs" src="@/assets/images/logo.png" style="height:30px;margin:8px 0 0 15px;">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <!-- <span class="navbar-toggler-icon"></span> -->
        </button>
        <div class="collapse navbar-collapse  justify-content-end" id="navbarTogglerDemo02">
          <ul class="navbar-nav mb-2 mb-lg-0 text-start">
            <li class="nav-item">
              <a class="nav-link" href="http://www.hffss.com/Home">首页</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="http://www.hffss.com/AboutUs">关于海峰</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="http://www.hffss.com/solution">解决方案</a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                教育基地
              </a>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" @click="QRCode(1)">金融监管大讲堂</a></li>
                <li><a class="dropdown-item" @click="QRCode(2)">私募申课</a></li>
                <li><a class="dropdown-item" @click="QRCode(3)">峰信使</a></li>
                <li><a class="dropdown-item" href="http://edu.hffss.com/">投教基地</a></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                新闻资讯
              </a>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="http://www.hffss.com/news/c-3040">客户风采</a></li>
                <li><a class="dropdown-item" href="http://www.hffss.com/news/c-3">海峰思考</a></li>
                <li><a class="dropdown-item" href="http://www.hffss.com/news/c-2">行业动态</a></li>
                <li><a class="dropdown-item" href="http://www.hffss.com/news/c-5">私募法规</a></li>
                <li><a class="dropdown-item" href="http://www.hffss.com/news/c-6">媒体报道</a></li>
                <li><a class="dropdown-item" href="http://www.hffss.com/news/c-20">私募法规</a></li>
              </ul>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="http://www.hffss.com/Rules/Index/3031">双语资管</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="http://www.hffss.com/AboutUs/contactus">联系我们</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <el-dialog
      title="二维码"
      :visible.sync="QRCodeBox"
      class="QRCode"
      width="600px"
      :before-close="beforeClose">
      <div>
        <p>
          <img v-if="QRCodeCode==1" src="@/assets/images/dajiangtang.jpg" alt="">
          <img v-if="QRCodeCode==2" src="@/assets/images/simushenke.jpg" alt="">
          <img v-if="QRCodeCode==3" src="@/assets/images/fengxins.png" alt="">
        </p>
        <p>{{QRCodeWord1}}</p>
        <p>{{QRCodeWord2}}</p>
      </div>
    </el-dialog>
 </div>
</template>

<script>
export default {
  name:'webHeader',
  data(){
    return{
      QRCodeBox:false,
      QRCodeCode:'',
      QRCodeWord2:'',
      QRCodeWord1:''
    }
  },
  methods:{
    QRCode(code){
      this.QRCodeCode = code
      if(code==1){
        this.QRCodeWord1 = '扫描关注“金融监管大讲堂”公众号'
        this.QRCodeWord2 = '获取最新热点资讯及法规解读'
      }else if(code==2){
        this.QRCodeWord1 = '扫描关注“海峰私募申课”二维码'
        this.QRCodeWord2 = '免费获取最热培训课程'
      }else{
        this.QRCodeWord1 = '扫描关注“峰信使”公众号'
        this.QRCodeWord2 = '解决与协会沟通的最后一公里'
      }
      this.QRCodeBox = true
    },
    beforeClose(){
      this.QRCodeBox = false

    }
  }

}

</script>
<style scoped lang='scss'>
#head_div{
  background-color: #000;
  height: 25px;
  line-height: 25px;
  .hidden-xs {
    display: block ;
  }
  .phone-span {
    float: left;
    margin-right: 40px;
    color: #F2F4F3;
    font-size: 12px;
    .conmmon-a {
      color: #428bca;
      text-decoration: none !important;
    }
    .conmmon-a:hover {
      color: #2a6496;
    }
  }
}
.navbar{
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7) !important;
  border-radius: 0;
  border: 0;
  margin-bottom: 0;
  position: absolute;
  top: 24px;
  left: 0;
  right: 0;
  z-index: 100;
  .dropdown-menu{
    background: rgba(0, 0, 0, 0.8) !important;
    li a{
      display: block;
      padding: 3px 20px;
      clear: both;
      font-weight: normal;
      white-space: nowrap;
      line-height: 40px !important;
      color: #fff !important;
      font-size: 14px;
    }
    li a:hover{
      background-color: #428bca;
    }
  }
  li a {
    font-size: 18px;
    padding-top: 15px;
    padding-bottom: 15px;
    color: #fff;
    padding: 10px 15px;
  }
  li a:hover {
    color: red;
  }
  .navbar-toggler{
    position: relative;
    float: right;
    padding: 9px 10px;
    margin-top: 8px;
    margin-right: 15px;
    margin-bottom: 8px;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
  }
  .icon-bar{
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    background-color: #ffffff;
    margin-top: 4px;
  }
}
 @media (min-width: 1200px) {
    .navbar {
      padding: 0 120px 20px;
    }
    #navbarTogglerDemo02 {
      padding: 20px 0 0;
    }
    .hidden-xs .hidden-sm{
      display: block;
    }
    .visible-xs,.visible-sm{
      display: none;
    }

  }

  @media (max-width: 1200px) and (min-width: 992px) {
    .navbar {
      padding: 0 0 20px;
    }
    #navbarTogglerDemo02 {
      padding: 20px 0 0;
    }
    .visible-xs,.hidden-xs.hidden-sm{
      display: none;
    }
    .visible-sm{
      display: block;
    }
  }

  @media (max-width: 992px) {
    .navbar {
      padding: 0 0 20px;
    }
    #navbarTogglerDemo02 {
      padding: 20px 0 0;
    }
    .visible-sm,.hidden-xs.hidden-sm{
      display: none;
    }
    .visible-xs{
      display: block;
    }
  }
a{
  text-decoration: none;
}
.QRCode{
  img{
    width: 150px;
  }
}
</style>